<template>
<div id="vender">
	
	<new-article></new-article>

	<loading-afip-ticket></loading-afip-ticket>

	<articles-loading-advise></articles-loading-advise>

	<current-acounts></current-acounts>


	<payment-methods></payment-methods>

	<nav-component></nav-component>
 
	<client></client>	
	<remito></remito>	

</div> 
</template>
<script>
import price_types from '@/mixins/vender/price_types'
import default_articles from '@/mixins/vender/default_articles'
import default_payment_method from '@/mixins/vender/default_payment_method'
import omitir_en_cuenta_corriente from '@/mixins/vender/omitir_en_cuenta_corriente'
import previus_sale from '@/mixins/vender/previus_sale/index'
import cajas from '@/mixins/vender/cajas'
export default {
	mixins: [price_types, default_articles, default_payment_method, omitir_en_cuenta_corriente, previus_sale, cajas],
	components: {  
		PaymentMethods: () => import('@/components/vender/modals/payment-methods/Index'),
		NewArticle: () => import('@/components/vender/modals/NewArticle'),
		LoadingAfipTicket: () => import('@/components/vender/modals/LoadingAfipTicket'),
		
		// Componentes
		CurrentAcounts: () => import('@/components/common/current-acounts/Index'),
		ArticlesLoadingAdvise: () => import('@/components/common/ArticlesLoadingAdvise'),
		NavComponent: () => import('@/components/vender/components/NavComponent'),
		Client: () => import('@/components/vender/components/client/Index'),
		Remito: () => import('@/components/vender/components/remito/Index'),
	},
	created() {
		console.log('created vender')
		// Inicializa el log de auditoría para una nueva sesión de venta.
		this.$store.commit('vender/init_sale_log')
		this.set_default_articles()

		this.setPriceType()

		this.setDefaultPaymentMethod()

		this.set_omitir_en_cuenta_corriente()

		this.set_caja_por_defecto()
		
		this.$store.commit('vender/clear_sale_log')
	},
	beforeRouteLeave(to, from, next) {
		this.$store.commit('sale/setSelected', [])
		// Limpia el log para evitar arrastre de auditoría entre ventas distintas.

		if (this.index_previus_sales != 0) {

			this.cancelPreviusSale()
		}
		next()
	},
	watch: {
		price_types() {
			console.log('cambiaron los tipos de precios, llamando a setPriceType')
			this.setPriceType()
		},
	},
}
</script>
<style scoped lang="sass">

// .list 
// 	width: 98%
// 	position: absolute
// 	z-index: 500
// 	max-height: 200px
// 	overflow-y: scroll

// .article-name 
// 	font-size: 1rem
// 	padding: 10px

// .list-group-border 
// 	border: 1px solid rgba(51, 51,51, .6)
// 	border-radius: 0.25rem 0.25rem 0 0

// .p-price-mobile 
// 	font-size: 1.5rem

// .btn-movil 
// 	padding: 8px 16px


// .col-relative 
// 	position: relative
// 	padding: 0px


// .col-total
// 	display: flex
// 	flex-direction: column
// 	justify-content: flex-start
// 	@media screen and (min-width: 768px)
// 		p 
// 			text-align: left
</style>